module.exports = __webpack_public_path__ + "img/AXIS_Favicon_green_32x32.9c75bd1e.png";